import React from "react";
import styled from "styled-components";

function DetailPage(props) {
  return (
    <>
      <DetailPageWrapper
        style={{
          ...props.style,
        }}
        ref={props.ref}
      >
        {props.children}
      </DetailPageWrapper>
    </>
  );
}

export default DetailPage;

const DetailPageWrapper = styled.div.attrs((props) => {})`
  width: 1044px;
  height: auto;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;
